import { useEffect, useState, useCallback } from 'react';
import api from '../lib/api';
import { ClipboardCheck, TriangleAlert, Wrench, Wifi, WifiOff } from 'lucide-react';
import { useSync } from '../context/SyncContext';

export default function InspectionBanner({ inspectionId }) {
  const { online } = useSync();
  const [p, setP] = useState(null);

  const load = useCallback(() => {
    if (!inspectionId) return;
    api.get(`/inspections/${inspectionId}/progress`).then((r) => setP(r.data)).catch(() => {});
  }, [inspectionId]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    const h = () => load();
    window.addEventListener('sync-updated', h);
    const t = setInterval(() => { if (document.visibilityState === 'visible') load(); }, 20000);
    return () => { window.removeEventListener('sync-updated', h); clearInterval(t); };
  }, [load]);

  if (!p) return null;
  const pct = p.sites_total ? Math.round((p.sites_done / p.sites_total) * 100) : 0;

  return (
    <div data-testid="inspection-banner" className="sticky top-0 z-30 -mx-4 border-b border-sky-300 bg-sky-50/95 px-4 py-2.5 backdrop-blur">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <ClipboardCheck className="h-4 w-4 text-sky-600" />
          <span className="text-xs font-semibold uppercase tracking-wide text-sky-800">
            {p.mode === 'install' ? 'Install Job' : 'Inspection'}{p.scope === 'multi' ? ' · Multi-Campaign' : ''}
          </span>
          <span className="flex items-center gap-1 rounded-full border border-slate-300 px-1.5 py-0.5 text-[10px] text-slate-600">
            {online ? <Wifi className="h-3 w-3 text-emerald-600" /> : <WifiOff className="h-3 w-3 text-amber-600" />}
            {online ? 'Online' : 'Offline'}
          </span>
        </div>
        <div className="flex items-center gap-3 text-xs">
          <span data-testid="banner-damage-reported" className="flex items-center gap-1 text-rose-700">
            <TriangleAlert className="h-3.5 w-3.5" /> {p.damage_reported} reported
          </span>
          <span data-testid="banner-damage-resolved" className="flex items-center gap-1 text-cyan-700">
            <Wrench className="h-3.5 w-3.5" /> {p.damage_resolved} resolved
          </span>
        </div>
      </div>
      <div className="mt-2 flex items-center gap-2">
        <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-slate-200">
          <div className="h-full rounded-full bg-sky-500 transition-all" style={{ width: `${pct}%` }} />
        </div>
        <span data-testid="banner-progress" className="font-mono text-[11px] text-sky-800">{p.sites_done}/{p.sites_total}</span>
      </div>
    </div>
  );
}
